<template>
  <div class="product">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" v-html="$t('areaProducts.headerTopText')" data-aos="fade-up"></div>
        <p data-aos="fade-up" data-aos-delay="100">{{$t('areaProducts.headerTopSubText')}}</p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p v-html="$t('areaProducts.headerText')" data-aos="fade-up" data-aos-delay="200"></p>
        <div class="btn-hover">
          <router-link to="/products/area/presentation" class="btn orange" data-aos="fade-up" data-aos-delay="250">
            {{$t('component.watchPresentation')}}<span/></router-link>
        </div>
      </div>
      <a @click="smoothScroll" data-scroll-offset="120" href="#top" class="more-about-us white" data-aos="fade-up"
         data-aos-delay="300"><span>{{$t('component.moreAboutUs')}}</span></a>
    </header>

    <div id="top" class="why-us-solution">
      <div class="top-text">
        <p v-html="$t('areaProducts.whyOurSolutionText')" data-aos="fade-up"></p>
        <h2 data-aos="fade-up">{{$t('areaProducts.whyOurSolution')}}</h2>
      </div>
      <div class="elements">
        <div class="element right clearfix">
          <div class="image" data-aos="flip-left">
            <figure class="hexagon-image resizable" style="background-image: url('/static/img/product/image4.jpg')">
              <div class="hexTop"></div>
              <div class="hexBottom"></div>
            </figure>
            <div class="line" data-aos="zoom-in-right"></div>
          </div>
          <div class="text-box">
            <div class="heading">
              <div class="hexagon" data-aos="flip-right" data-aos-delay="100"><span>1</span></div>
              <span class="text" data-aos="fade-up">{{$t('areaProducts.sectionOneTitle')}}</span></div>
            <ul>
              <li data-aos="fade-up" data-aos-delay="200">
                <span class="dot"></span><span class="text">{{$t('areaProducts.sectionOneText1')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="250">
                <span class="dot"></span><span class="text">{{$t('areaProducts.sectionOneText2')}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="element left clearfix">
          <div class="image" data-aos="flip-right">
            <figure class="hexagon-image resizable" style="background-image: url('/static/img/product/image2.jpg')">
              <div class="hexTop"></div>
              <div class="hexBottom"></div>
            </figure>
            <div class="line" data-aos="zoom-in-left"></div>
          </div>
          <div class="text-box">
            <div class="heading">
              <div class="hexagon" data-aos="flip-left" data-aos-delay="100"><span>2</span></div>
              <span class="text" data-aos="fade-up">{{$t('areaProducts.sectionTwoTitle')}}</span></div>
            <ul>
              <li data-aos="fade-up" data-aos-delay="200">
                <span class="dot"></span><span class="text">{{$t('areaProducts.sectionTwoText1')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="250">
                <strong>{{$t('areaProducts.sectionTwoText2')}}</strong>
              </li>
              <li data-aos="fade-up" data-aos-delay="300">
                <span class="dot"></span><span class="text">{{$t('areaProducts.sectionTwoText3')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="350">
                <span class="dot"></span><span class="text">{{$t('areaProducts.sectionTwoText4')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="400">
                <span class="dot"></span><span class="text">{{$t('areaProducts.sectionTwoText5')}}</span>
              </li>
              <li data-aos="fade-up" data-aos-delay="450">
                <span class="dot"></span><span class="text">{{$t('areaProducts.sectionTwoText6')}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-first orange-bg">


      <div class="image-boxes inline-boxes">
        <div class="container">
          <div class="box" data-aos="fade-up" data-aos-delay="100">
            <img src="/static/img/product/image-box-1.jpg" alt="team1">
          </div>
          <div class="box" data-aos="fade-up" data-aos-delay="150">
            <img src="/static/img/product/image-box-2.jpg" alt="team2">
          </div>
          <div class="box" data-aos="fade-up" data-aos-delay="200">
            <img src="/static/img/product/image-box-3.jpg" alt="team3">
          </div>
          <div class="box" data-aos="fade-up" data-aos-delay="250">
            <img src="/static/img/product/image-box-4.jpg" alt="team4">
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-last">
      <div class="content">
        <h2>{{$t('areaProducts.whyIShouldUseThis')}}</h2>
        <div class="elements">
          <div class="element">
            <Counter :data="circleValues[0]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="150">
              <p>{{$t('areaProducts.whyIShouldUseThisOneText')}}</p>
            </div>
          </div>
          <div class="element">
            <Counter :data="circleValues[1]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="250">
              <p>{{$t('areaProducts.whyIShouldUseThisTwoText')}}</p>
            </div>
          </div>
          <div class="element">
            <Counter :data="circleValues[2]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="350">
              <p>{{$t('areaProducts.whyIShouldUseThisThreeText')}}</p>
            </div>
          </div>
          <div class="element">
            <Counter :data="circleValues[3]"></Counter>
            <div class="bottom" data-aos="fade-up" data-aos-delay="450">
              <p>{{$t('areaProducts.whyIShouldUseThisFourText')}}</p>
            </div>
          </div>
        </div>
        <div class="btn-hover">
          <router-link to="/products/area/presentation" class="btn orange" data-aos="fade-up">
            {{$t('component.watchPresentation')}}<span/></router-link>
        </div>
      </div>
    </div>
    <footer-more-information :modalpage="'area'"/>
    <footer-main/>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import VideoBox from '../components/VideoBox';
  import Counter from '../components/Counter';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'area-product',
    components: {
      FooterMain,
      FooterMoreInformation,
      VideoBox,
      Counter
    },
    data: function () {
      return {
        circleValues: [
          {
            before: this.$t('areaProducts.whyIShouldUseThisOneTopBefore'),
            val: this.$t('areaProducts.whyIShouldUseThisOneTop'),
            after: this.$t('areaProducts.whyIShouldUseThisOneTopAfter'),
          },
          {
            before: this.$t('areaProducts.whyIShouldUseThisTwoTopBefore'),
            val: this.$t('areaProducts.whyIShouldUseThisTwoTop'),
            after: this.$t('areaProducts.whyIShouldUseThisTwoTopAfter'),
          },
          {
            before: this.$t('areaProducts.whyIShouldUseThisThreeTopBefore'),
            val: this.$t('areaProducts.whyIShouldUseThisThreeTop'),
            after: this.$t('areaProducts.whyIShouldUseThisThreeTopAfter'),
          },
          {
            before: this.$t('areaProducts.whyIShouldUseThisFourTopBefore'),
            val: this.$t('areaProducts.whyIShouldUseThisFourTop'),
            after: this.$t('areaProducts.whyIShouldUseThisFourTopAfter'),
          },
        ]

      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      smoothScroll: () => smoothScroll
    },
    methods: {
    }
  }
</script>

<style scoped="">
  .product .page-header {
    background: url(/static/img/product/header-area.jpg) no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
  }

  .product .bottom-last:after {
    background: url(/static/img/product/bottom-last-area.jpg) no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
  }
</style>




// WEBPACK FOOTER //
// AreaProduct.vue?3c6081fc